import { buildVideoPlayer } from "./video-player";
import { buildLockedVideo } from "./locked-player";
//
// Loop over all video player placeholders and initialize preview
export default function initializeEmbeddedVideos(autoplay) {
  var videos = $("div.video-player");

  videos.each(function(index, element) {
    var $this = $(element),
        videoId = $this.data('videoId');

    // Fetch the video's information from the api
    $.get({
        url: '/media/' + videoId,
        dataType: 'json'
      })
      .done(function(video) {
        if (video.public || currentUser.subscriber) {
          buildVideoPlayer(element, video, autoplay);
        } else {
          buildLockedVideo(element, video);
        };
      });
  });
};
